var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flw"},[_c('vk-button',{staticClass:"uk-margin uk-button-red",attrs:{"size":"large"},on:{"click":_vm.makePayment}},[_vm._v("Pay "+_vm._s(_vm.total))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }